export function initHeader(): void {
  const hamburger = document.querySelector<HTMLElement>(".hamburger");
  const menu = document.getElementById("mobile-menu");
  const closeBtn = document.querySelector<HTMLElement>(".close-menu");
  const backdrop = document.getElementById("mobile-menu-backdrop");

  if (!hamburger || !menu) return;

  function toggleMenu(show: boolean): void {
    if (!menu || !hamburger) return;

    if (show) {
      menu.classList.add("open");
      menu.setAttribute("aria-hidden", "false");
      hamburger.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    } else {
      menu.classList.remove("open");
      menu.setAttribute("aria-hidden", "true");
      hamburger.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }
  }

  hamburger.addEventListener("click", () => toggleMenu(true));

  if (closeBtn) {
    closeBtn.addEventListener("click", () => toggleMenu(false));
  }
  if (backdrop) {
    backdrop.addEventListener("click", () => toggleMenu(false));
  }
}

document.addEventListener("turbo:load", initHeader);
document.addEventListener("DOMContentLoaded", initHeader);
